{
	"update-info": {
		"forced": {
			"message": "La versión actual ya no es compatible. \nVaya a su tienda de aplicaciones y actualice a la última versión.",
			"title": "Le rogamos que actualice la aplicación."
		},
		"optional": {
			"title": "¡Nueva versión disponible!",
			"message": "Actualice a la última versión cuando esté listo para disfrutar de las funciones más recientes."
		},
		"whats-new": "Qué hay de nuevo",
		"update-now": "Actualizar ahora",
		"maybe-later": "tal vez más tarde",
		"version": "Versión"
	}
}
